import { buildOfferListColumns, SOURCING_HIDDEN_COLUMNS } from '@/features/offers/constants/offerListColumns'
import { MySourcingOfferDisplayLevel } from '@/features/tableProfiles/constants/tableProfile.constant'

// My Sourcing is the offer list with the sales-side columns taken out. Anything
// added to the offer list appears here too unless SOURCING_HIDDEN_COLUMNS says
// otherwise.
export const getMySourcingTableColumns = (options, displayLevel = MySourcingOfferDisplayLevel.COST_BUDGET) =>
  buildOfferListColumns(options, displayLevel, SOURCING_HIDDEN_COLUMNS)
